module.exports = __webpack_public_path__ + "img/40_38_077_840.975346eb.jpg";